<template>
<!-- 工作日报 -->
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="巡检员">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.userName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="社区">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.communityName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">巡检日期</span>
          <el-date-picker
            size="mini"
            v-model="inspectionDate"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="false"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
      :tableCellClassName="tableCellClassName"
      :tableCellClick="tableCellClick"
    >
      <template #amTimeScope="slotData">
        {{
          slotData.data.row.inspectionAMStart
            ? slotData.data.row.inspectionAMStart
            : "暂无"
        }}
        -
        {{
          slotData.data.row.inspectionAMEnd
            ? slotData.data.row.inspectionAMEnd
            : "暂无"
        }}
      </template>
      <template #pmTimeScope="slotData">
        {{
          slotData.data.row.inspectionPMStart
            ? slotData.data.row.inspectionPMStart
            : "暂无"
        }}
        -
        {{
          slotData.data.row.inspectionPMEnd
            ? slotData.data.row.inspectionPMEnd
            : "暂无"
        }}
      </template>
      <template #handlerSlot="slotData">
        <div
          v-for="(item, index) in slotData.data.row.unOnDutyList"
          :key="index"
        >
          {{ item }}
        </div>
      </template>
    </e-table>

    <el-dialog :title="dialogTitle" :visible.sync="communityCountDialog">
      <div v-if="dialogTitle === '巡检桶站'">
        <div style="margin-bottom: 20px">
          <span>上午</span>
          <br />
          <div
            v-if="inspectionGSNames.inspectionAMGSNames.length === 0"
            style="margin: 10px; color: gray"
          >
            暂无
          </div>
          <div v-else>
            <el-tag
              class="cursorStyle"
              style="margin: 5px"
              v-for="(item, index) in inspectionGSNames.inspectionAMGSNames"
              :key="index"
              @click="getPhotoHandle(item, inspectionGSNames, 'AM')"
              >{{ item.garbageStationName }}</el-tag
            >
          </div>
        </div>
        <div>
          下午<br />
          <div
            v-if="inspectionGSNames.inspectionPMGSNames.length === 0"
            style="margin: 10px; color: gray"
          >
            暂无
          </div>
          <div v-else>
            <el-tag
              class="cursorStyle"
              style="margin: 5px"
              v-for="(item, index) in inspectionGSNames.inspectionPMGSNames"
              :key="index"
              @click="getPhotoHandle(item, inspectionGSNames, 'PM')"
              >{{ item.garbageStationName }}</el-tag
            >
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="inspectionCommunityNames.length !== 0">
          <el-tag
            style="margin: 5px"
            v-for="(item, index) in inspectionCommunityNames"
            :key="index"
            >{{ item }}</el-tag
          >
        </div>
        <div v-else style="display: flex; justify-content: center">
          <span> 暂无 </span>
        </div>
      </div>

     <div class="images" v-viewer="{fullscreen: false,movable: false,title: true,scalable: false, zoomable: false}">
      <img v-for="src in inspectPhoto" :src="src.photo" :alt="src.date" :key="src.photo">
    </div>
    </el-dialog>
    

  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";

  import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  Vue.use(Viewer)
export default {
  components: { eTable },
  mixins: [listMixin],
  data() {
    return {
      inspectionDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      url: {
        list: "/wlDailyWorkReport/dayList",
        getPhoto: "/wlDailyWorkReport/recordDetail",
      },
      //字段权限
      loading: false,
      queryParam: {
        userName: "",
        communityName: "",
        inspectionDateStart: "",
        inspectionDateEnd: "",
      },
      columns: [
        { field: "userName", label: "巡检员" },
        { field: "inspectionDate", label: "巡检日期" },
        {
          width: 260,
          label: "上午巡检时间范围",
          slotName: "amTimeScope",
          columnType: "slot",
        },
        {
          width: 260,
          label: "下午巡检时间范围",
          slotName: "pmTimeScope",
          columnType: "slot",
        },
        { field: "inspectionCommunityNum", label: "巡检小区数量" },
        { field: "inspectionGSNum", label: "巡检桶站数量" },
        { field: "invertGSNames.length", label: "未巡检桶站数量" },
        { field: "onDutyRate", label: "指导员在岗率" },
        { field: "onTidyRate", label: "桶站整洁率" },
        { field: "isPureRate", label: "桶站纯净率" },
        { field: "isWearRate", label: "指导员着装率" },
        { field: "lidStatusRate", label: "开盖率" },
        { field: "punishmentRate", label: "处罚率" },
        {
          width: 200,
          label: "处罚详情",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      dialogTitle: "",
      communityCountDialog: false,
      inspectionCommunityNames: [],
      inspectionGSNames: [],
      innerVisible: false,
      inspectPhoto: []
    };
  },
  updated() {
    this.dataSource.forEach((item) => {
      let itemDate = item.inspectionDate.split(" ");
      item.inspectionDate = itemDate[0];
    });
  },
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  methods: {
    dateChange(date) {
      this.queryParam.inspectionDateStart = date[0] + " 00:00:00";
      this.queryParam.inspectionDateEnd = date[1] + " 23:59:59";
    },
    tableCellClassName({ column, columnIndex }) {
      if (
        column.property === "inspectionCommunityNum" ||
        column.property === "inspectionGSNum" ||
        column.property === "invertGSNames.length"
      ) {
        return "blue";
      }
      return "";
    },
    tableCellClick(row, column, cell, event) {
      if (
        column.property === "inspectionCommunityNum" ||
        column.property === "inspectionGSNum" ||
        column.property === "invertGSNames.length"
      ) {
        this.dialogTitle = "";
        this.inspectionCommunityNames = [];
        this.inspectionAMGSNames = [];
        this.inspectionPMGSNames = [];

        this.communityCountDialog = true;
      }
      if (column.property === "inspectionCommunityNum") {
        this.dialogTitle = "巡检小区";
        this.inspectionCommunityNames = row.inspectionCommunityNames;
      }
      if (column.property === "inspectionGSNum") {
        this.dialogTitle = "巡检桶站";
        this.inspectionGSNames = row;
      }
      if (column.property === "invertGSNames.length") {
        this.dialogTitle = "未巡检桶站";
        this.inspectionCommunityNames = row.invertGSNames;
      }
    },
    getPhotoHandle(item, parent, flag) {
      httpAction(
        `/wlDailyWorkReport/recordDetail?garbageStationId=${item.id}&inspectionDate=${parent.inspectionDate}&flag=${flag}&inspectionUserId=${parent.inspectionUserId}`,
        {},
        "get"
      ).then(({ code, data }) => {
        if (code === 200) {
          this.inspectPhoto = data
        }
      });
      setTimeout(() => {
        const viewer = this.$el.querySelector('.images').$viewer
        console.log(viewer);
        viewer.show()
      }, 1000);
    },
    handleClose() {
      this.innerVisible = false;
      this.inspectPhoto = [];
      this.inspectPhotoIndex = 0;
      this.inspectPhotoTime = [];
    },
    previousImg() {
      this.inspectPhotoIndex--;
      if (this.inspectPhotoIndex < 0)
        this.inspectPhotoIndex = this.inspectPhoto.length - 1;
    },
    nextImg() {
      this.inspectPhotoIndex++;
      if (this.inspectPhotoIndex > this.inspectPhoto.length - 1)
        this.inspectPhotoIndex = 0;
    },
    clockwiseImg() {},
    searchReset () {
      this.queryParam = {}
      this.inspectionDate = ''
      this.searchQuery()
    },
  },
};
</script>

<style scoped>
/deep/.el-table .blue {
  color: blue !important;
  text-decoration: underline;
  cursor: pointer;
}

.search_wrap {
  margin: 10px 0;
}

.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}


.cursorStyle {
  cursor: pointer;
}

.images {
  display: none;
}

</style>